import { Timestamp } from 'firebase/firestore';

/**
 * Convertit une valeur de date Firestore (Timestamp ou string) en objet Date JavaScript
 * @param dateValue Valeur de date (Timestamp, string ISO ou undefined)
 * @param defaultValue Valeur par défaut si dateValue est undefined
 * @returns Objet Date JavaScript ou la valeur par défaut
 */
export const convertFirestoreDate = (dateValue: any, defaultValue: Date | null = null): Date | null => {
  // Si la valeur est undefined ou null, retourner la valeur par défaut
  if (dateValue == null) {
    return defaultValue;
  }
  
  // Si c'est un Timestamp Firestore
  if (dateValue && typeof dateValue.toDate === 'function') {
    return dateValue.toDate();
  }
  
  // Si c'est une chaîne de caractères (ISO string)
  if (typeof dateValue === 'string') {
    try {
      return new Date(dateValue);
    } catch (error) {
      console.error('Error converting date string to Date object:', error);
      return defaultValue;
    }
  }
  
  // Si c'est déjà un objet Date
  if (dateValue instanceof Date) {
    return dateValue;
  }
  
  // Si le type n'est pas reconnu
  console.warn('Unknown date value type:', dateValue);
  return defaultValue;
};
